<div class="modal-body width-500">
	<div class="layout-auto-1-auto">
		<span class="modal-header">
			{{getRessource('modalHeader')}}
		</span>
		<div class="content">
			<exg-checkbox
				class="typo-small"
				[caption]="getRessource('withReceipts')"
				[(ngModel)]="reportParams.withReceipts">
			</exg-checkbox>
			<exg-checkbox
				class="typo-small"
				[caption]="getRessource('withReviews')"
				[(ngModel)]="reportParams.withReviews">
			</exg-checkbox>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()" class="md-btn">
				{{getRessource('download')}}
			</button>
		</div>
	</div>
</div>
